export default "__VITE_ASSET__e3713891__"